// frontend/src/hooks/useRootAttribute.js
//
// Reactive read of one attribute on <html>. AuthContext's applyTheme and
// applySidebar write data-theme / data-sidebar synchronously on the click,
// before any React state update or PATCH round-trip, so a component reading
// the attribute shows the new state in the same paint. userContext.user only
// catches up when the PATCH answers. Returns null while the attribute is absent.

import { useCallback, useSyncExternalStore } from 'react';

const read = (name) => document.documentElement.getAttribute(name);

export default function useRootAttribute(name) {
  const subscribe = useCallback((onChange) => {
    const observer = new MutationObserver(onChange);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: [name],
    });
    return () => observer.disconnect();
  }, [name]);

  return useSyncExternalStore(subscribe, () => read(name));
}
